import * as yup from "yup";

export const AccountantBankSetupValidationSchema = yup.object().shape({
  accountantId: yup.string().required("Accountant is required"),
  accountNo: yup.string().required("Bank Account No is required"),
  branchTransitNumber: yup
    .string()
    .required("Bank Branch Transit Number is required"),
  bankFinancialNo: yup.string().required("Bank Bank Financial No is required"),
});
